import "@fancyapps/fancybox";
import "@fortawesome/fontawesome-free/js/all.js";
import "./foundation.js";
import "./fontLoad.js";
import "./chooseCity.js";
import "./carousels.js";
import "./handleInputNumber.js";
import "./handleFiles.js";
import "./lazy-images.js";
import "./handleRequestProduct";

import "../scss/style.scss";
(function($) {
  "use strict";
  window.$ = window.jQuery = $;
  function LinkClick(element) {
    this.element = element;
    this.run = function() {
      let link = $(this.element)
        .find(".button")
        .attr("href");

      if (link == undefined || link == "undefined") return false;

      document.location.href = link;
    };
  }

  let links = [".advantage", ".production", ".catalog-category", ".news-tile"];

  links.forEach(element => {
    $(element).on("click", function(e) {
      e.preventDefault();
      var obj = new LinkClick(this);
      obj.run();
    });
  });

  // Удалить. Служит для показа клиенту.
  let str = document.location.href;
  if (str.indexOf("company") + 1) {
    $('[data-toggle-hover-dd="menu_item_2"]').addClass("cat__link__active");
  }
  if (str.indexOf("buyers") + 1) {
    $('[data-toggle-hover-dd="menu_item_1"]').addClass("cat__link__active");
  }

  $(function () {
    $(function () {
    
      var $modalForm = $(".productModalBuy");
      var popup = new Foundation.Reveal($modalForm);
      var kgInput = "#calcKg";
      var tInput = "#calcT";
      var countInput = "#calcCount";
      var addCardButton = "#inputCartAdd";
      var priceResultHasVat = "#resultSummPriceHasVat";
      var priceResultNotVat = "#resultSummPriceNotVat";
      var modalCountOpener = 0;
      // Добавление в корзину
      var addtoCard = function (event) {
          event.preventDefault();
  
          var $idProduct = $(this).attr("data-id");
  
          if ($idProduct) {
  
              $.ajax({
                  url: "/local/templates/alfametal/ajax.php?idProduct=" + $idProduct,
                  method: "POST",
                  data: {
                      action: "getModalBuy",
                  },
                  success: function ($response) {
  
                      var $data = JSON.parse($response);
  
                      var $preview_text = $data.data.preview_text;
                      var $name = $data.data.name;
                      var $opt1 = $data.data.prices.opt1;
                      var $opt2 = $data.data.prices.opt2;
                      var $vat = $data.data.vat;
                      if ($vat) {
                          var $textVat = "c НДС ";
                      } else {
                          var $textVat = "без НДС "
                      }
                      if ($data.success == true) {
  
                        let weightByItem = parseInt($data.data.properties.VESEDINITSY.VALUE);
                          $("#productModalBuyName").html($name);
                          $("#productModalBuyName").attr("data-id", $idProduct);
                          $("#productModalBuyPrice1").html($opt1);
                          $("#productModalBuyPrice2").html($opt2)
                          $('[name="weightByItem"]').val(weightByItem);
                          $(".productModalBuyVat").html($textVat);
                          $(".productModalBuy-secondary").hide();
  
                          if (!weightByItem){
                            $('#calcCount').attr('disabled',true);
                          }
                          $(".productModalBuy-main").show();
                          popup.open();
                          if (modalCountOpener != 0) {
                              calcModal("kg");
                          }
                          modalCountOpener += 1;
  
                      } else {
                          console.log("error");
                      }
                  }
              });
          }
      }
      var clearFields = function () {
  
          $(kgInput).val(0);
          $(tInput).val(0);
          $(countInput).val(0);
          $(priceResult).text(0);
  
      }
  
      var calcModal = function(type) {
          var productId = $("#productModalBuyName").attr("data-id");
          var kgInputValue = $(kgInput).val();
          var tInputValue = $(tInput).val();
          var countInputValue = $(countInput).val();
          var check = checkInputs();
  
          if (check) {
              if (productId) {
  
                  $.ajax({
                      url: "/local/templates/alfametal/ajax.php?idProduct=" + productId,
                      method: "POST",
                      data: {
                          action: "calcModal",
                          kgvalue: kgInputValue,
                          countvalue: countInputValue,
                          tvalue: tInputValue,
                          typeOperation: type
                      },
                      success: function (response) {
                          var $response = JSON.parse(response);
                          if ($response.success == true) {
                              $(priceResultHasVat).text($response.priceHasVat);
                              $(priceResultNotVat).text($response.resultPriceNotVat);
                              $(kgInput).val($response.kg);
                              $(tInput).val($response.t);
                              console.log($response);
                              if ($response.count_view !== "N") {
                                  $(countInput).val($response.count);
  
                              } else {
                                  $(countInput).val("");
                              }
  
                          }
                      }
                  });
              }
          } else {
              return false;
          }
  
  
      }
      var resultAddcart = function (event) {
          event.preventDefault();
  
          var productId = $("#productModalBuyName").attr("data-id");
          var check = checkInputs();
          if (!check) return false;
          if (productId) {
  
              var kgInputValue = $(kgInput).val();
              var tInputValue = $(tInput).val();
              var countInputValue = $(countInput).val();
              $.ajax({
                  url: "/local/templates/alfametal/ajax.php?idProduct=" + productId,
                  method: "POST",
                  data: {
                      action: "resultAddcart",
                      count: countInputValue,
                      t: tInputValue,
                      kg: kgInputValue
                  },
                  success: function (response) {
                      var $response = JSON.parse(response);
  
                      if ($response.success == true) {
                          console.log($response);
                          $(".productModalBuy-main").fadeOut("fast");
                          $(".productModalBuy-secondary").fadeIn();
  
                      } else {
                          console.log($response.error);
                      }
                  }
  
              });
          }
      }
  
      var checkInputs = function () {
  
          var kgInputValue = $(kgInput).val();
          var tInputValue = $(tInput).val();
          var countInputValue = $(countInput).val();
  
  
          if ((!kgInputValue || kgInputValue <= 0) && (!tInputValue || tInputValue <= 0) && (!countInputValue || countInputValue <= 0)) {
              $(kgInput).addClass("alert");
              $(tInput).addClass("alert");
              $(countInput).addClass("alert");
              return false;
          } else {
              $(kgInput).removeClass("alert");
              $(tInput).removeClass("alert");
              $(countInput).removeClass("alert");
              return true;
          }
      }
  
  
      var closeModal = function (event) {
          popup.close();
      }
      //  Купить
  
  
      $(document).on("click", ".addToCard", addtoCard);
      // Закрыть модальное окно
      $(document).on("click", ".closeModalProductModal", closeModal);
  
  
      $(document).on("keyup", kgInput, function () {
          calcModal("kg");
      });
  
      $(document).on("keyup", tInput,function () {
          calcModal("t");
      });
  
      $(document).on("keyup", countInput,function () {
          calcModal("count");
      });
  
      $(document).on("click",addCardButton, resultAddcart);
  
      // CHANGE WH
     $(document).on("change",".catalog-filter__wh", function () {
  
  
          var code = $(this).val();
  
          $.ajax({
              url: '/ajax/change_region.php',
              method: "POST",
              data: {
                  code: code
              },
              success: function (data) {
                  if (data != 'ERROR') {
                      document.location.reload(true);
                  }
              }
          });
      });
  
      // CHANGE NDS
      $(document).on('change', ".step__nds",function () {
  
          var vat_checkbox = $(this);
          var withvat = 'N';
  
          if (vat_checkbox.is(':checked'))
              withvat = 'Y';
  
          vat_checkbox.attr('disabled', 'disabled');
  
          $.ajax({
              url: '/ajax/vat_included.php',
              method: "POST",
              data: {
                  withvat: withvat
              },
              success: function (data) {
                  console.log(data);
                  if (data != 'ERROR') {
                      if (data == "Y") {
                          document.location.reload(true);
                      } else {
                          document.location.reload(true);
                      }
                  }
  
                  vat_checkbox.removeAttr('disabled');
              }
          });
      });
  
  
      // BITRIX24FORM
      var initB24CrmDvsForm = function (name) {
  
          var avaluexName = name;
  
          return {
              "id": "8", "lang": "ru", "sec": "tfkdwy", "type": "button", "click": "", "ref":
                  'https://b24-ysg90y.bitrix24.ru/bitrix/js/crm/form_loader.js', "fields": {
                      "values":
                          { 'LEAD_COMMENTS': 'Запрашиваю цену ' + avaluexName.LEAD_TITLE }
                  }
          };
  
      }
  
  
      var b24paramsload = initB24CrmDvsForm({});
  
      (function (w, d, u, b) {
          w['Bitrix24FormObject'] = b;
          w[b] = w[b] || function () {
              arguments[0].ref = u;
              (w[b].forms = w[b].forms || []).push(arguments[0])
          };
          if (w[b]['forms']) return;
          var s = d.createElement('script');
          var r = 1 * new Date();
          s.async = 1;
          s.src = u + '?' + r;
          var h = d.getElementsByTagName('script')[0];
          h.parentNode.insertBefore(s, h);
      })(window, document, b24paramsload.ref, 'b24form');
  
  
      function reinitB24Dvsform(nVal) {
          if (!window.Bitrix24FormObject || !window[window.Bitrix24FormObject])
              return;
          if (!window[window.Bitrix24FormObject].forms)
              return;
          // Уничтожаем форму
          Bitrix24FormLoader.unload(b24paramsload);
          // Пересоздаём параметры формы
          b24paramsload = initB24CrmDvsForm({ 'LEAD_TITLE': nVal });
          // Инициируем форму с новыми данными
          Bitrix24FormLoader.params = b24paramsload;
          Bitrix24FormLoader.init();
          // Открываем попап
          Bitrix24FormLoader.showPopup(b24paramsload);
      }
  
      /*$(document).on("click", ".requestProduct",function () {
  
  
          name = $(this).attr("data-name");
          if (name) {
              reinitB24Dvsform(name);
          }
  
      });*/
  
  
  
      //  Открыть:  кнопки сортировки
  
      $(document).on("click", ".catalog-filter__button", function() {
  
                var id = "#"+$(this).data("toggle");
  
                const dropdown = new Foundation.Dropdown($(id));
  
                dropdown.open();
  
  
      });
  
  });
  });
})(jQuery);
